import { HttpClient } from '@angular/common/http';
import { computed, effect, Injectable, signal } from '@angular/core';
import { BehaviorSubject, catchError, finalize, Observable, tap } from 'rxjs';
import { Binder, OwnerItem } from 'src/app/models/binder.model';
import { StandardOwnerItem } from 'src/app/models/standard-owner-item.model';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { BinderService } from './binder.service';
import { SettingsDialogService } from '../app/settings-dialog.service';
import { isEqual } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class OwnerItemsService {
  standardOwnerItems = signal<StandardOwnerItem[]>([]);
  // ownerItems = signal<OwnerItem[]>([]);

  // addedOwnerItems = signal<OwnerItem[]>([]);
  // removedOwnerItems = signal<OwnerItem[]>([]);
  // editedOwnerItems = signal<OwnerItem[]>([]);

  BASE_URL = environment.landmark_API_URL+'/owneritems';

  private _pristine = signal<OwnerItem[]>([]);
  private _items = signal<OwnerItem[]>([]);
  private _loading = signal(false);

  readonly items = computed(() => this._items());
  readonly loading = this._loading.asReadonly();
  readonly isDirty = computed(() => !isEqual(this._pristine(), this._items()));

  readonly ownerItems = computed(() => this._pristine());

  constructor(
    private http: HttpClient, 
    private binderModelService: BinderService,
    private messageService: MessageService,
    private settingsDialogService: SettingsDialogService
  ) { 
    effect(() => {
      const binder = this.binderModelService.currentBinder();
      if(binder) {
        this.loadFromBinder(binder);
      }
    });
  }

  getStandardOwnerItems(filterFIDs?: number[]) {
    console.log('getting standard owner items');
    const body = {
      fidlist: filterFIDs ? filterFIDs : []
    };
    this.http.post<StandardOwnerItem[]>(this.BASE_URL, body).subscribe(data => {
      this.standardOwnerItems.set(data);
    });
  }

  setItems(newItems: OwnerItem[]) {
    this._items.set(newItems);
  }

  // populateSelectedOwnerItems(binder: Binder) {
  //   if (binder.OwnerItems) {
  //     this.ownerItems.set(binder.OwnerItems.sort((a, b) => a.ItemOrder - b.ItemOrder));
  //   }
  // }

  // addOwnerItem(item: OwnerItem) {
  //   this.addedOwnerItems.set([...this.addedOwnerItems(), item]);
  //   this.removedOwnerItems.set(this.removedOwnerItems().filter(i => i.ItemID !== item.ItemID));
  // }

  // removeOwnerItem(item: OwnerItem) {
  //   if(!item.newItem) {
  //   this.removedOwnerItems.set([...this.removedOwnerItems(), item]);
  //   } else {
  //     this.addedOwnerItems.set(this.addedOwnerItems().filter(i => i.ItemID !== item.ItemID));
  //   }
  //   this.editedOwnerItems.set(this.editedOwnerItems().filter(i => i.ItemID !== item.ItemID));
  // }

  // editOwnerItem(item: OwnerItem) {
  //   if(!item.newItem) {
  //   this.editedOwnerItems.set([...this.editedOwnerItems(), item]);
  //   this.addedOwnerItems.set(this.addedOwnerItems().filter(i => i.ItemID !== item.ItemID));
  //   }
  //   else {
  //     this.addedOwnerItems.set([...this.addedOwnerItems(), item]);
  //   }
  //   this.removedOwnerItems.set(this.removedOwnerItems().filter(i => i.ItemID !== item.ItemID));
  // }

  // resetOwnerItems() {
  //   this.addedOwnerItems.set([]);
  //   this.removedOwnerItems.set([]);
  //   this.editedOwnerItems.set([]);
  // }

  // saveOwnerItems(addedOwnerItems: OwnerItem[], removedOwnerItems: OwnerItem[], editedOwnerItems: OwnerItem[]): Observable<{addedOwnerItems: OwnerItem[], removedOwnerItems: OwnerItem[], patchedOwnerItems: OwnerItem[]}> {
  //   const modifiedAddedOwnerItems = addedOwnerItems.map(item => {
  //     const { ItemID, StandardOwnerItems, ...rest } = item;
  //     return rest;
  //   });
  //   const modifiedPatchedOwnerItems = editedOwnerItems.map(item => {
  //     const { BinderID, StandardOwnerItems, ...rest } = item;
  //     return rest;
  //   });
  //   const removedIds = removedOwnerItems.map(item => item.ItemID);
  //   const body = {
  //     addedOwnerItems: modifiedAddedOwnerItems,
  //     removedOwnerItems: removedIds,
  //     patchedOwnerItems: modifiedPatchedOwnerItems
  //   };
  //   return this.http.post<{addedOwnerItems: OwnerItem[], removedOwnerItems: OwnerItem[], patchedOwnerItems: OwnerItem[]}>(this.BASE_URL+'/save', body)
  //     .pipe(
  //       tap(data => {
  //         this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Owner items saved successfully' });
  //         this.binderModelService.injectOwnerItems(data.addedOwnerItems, data.removedOwnerItems, data.patchedOwnerItems);

  //       }),
  //       catchError(error => {
  //         this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to save owner items' });
  //         throw error;
  //       })
  //     );
  // }



  loadFromBinder(binder:Binder) {
    const data = binder.OwnerItems || [];
      this._pristine.set(data);
      this._items.set(structuredClone(data));
  }

  updateItem(index: number, partial: Partial<OwnerItem>) {
    const updated = [...this._items()];
    updated[index] = { ...updated[index], ...partial };
    this._items.set(updated);
  }

  addItem(newItem: OwnerItem) {
    this._items.set([...this._items(), newItem]);
  }

  deleteItem(item: OwnerItem) {
    const copy = [...this._items()];
    copy.splice(copy.findIndex(i => i.ItemID === item.ItemID), 1);
    this._items.set(copy);
  }

  reset() {
    this._items.set(structuredClone(this._pristine()));
  }

  save() {
    this._loading.set(true);
    const binderId = this.binderModelService.currentBinder()?.BinderID;
    if(binderId) {
    this.http.put<OwnerItem[]>(this.BASE_URL + '/overwrite/' + binderId, this._items())
      .pipe(finalize(() => this._loading.set(false)))
      .subscribe(saved => {
        this._pristine.set(saved);
        this._items.set(structuredClone(saved));
        this.settingsDialogService.closeDialog();
      });
  }
}
}
